import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1rem'
  },

  name: {
    margin: '1rem 0 0.75rem 0',
    fontSize: theme.size.sm
  },

  children: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1.5rem'
  }
}))

export default useStyles
